/**
 * API Configuration
 * Centralized API base URL configuration
 */

/**
 * Get the API base URL based on environment
 * - In development (localhost): use local backend
 * - In production: use same origin (backend serves frontend)
 */
export function getApiBase(): string {
  // In browser, check if we're on localhost
  if (typeof window !== 'undefined') {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      return 'http://localhost:3001';
    }
    // In production, API is on same origin
    return '';
  }
  
  // Server-side rendering or Node.js environment
  return process.env.VITE_API_BASE_URL || 'http://localhost:3001';
}

/**
 * Build a full API URL
 */
export function buildApiUrl(path: string): string {
  const base = getApiBase();
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalizedPath}`;
}
